import { useSafeAreaStyles } from "@/hooks/utils/use-safe-area-styles";
import { IonContent } from "@ionic/react";
import { ComponentProps, ReactNode } from "react";

type IonContentProps = ComponentProps<typeof IonContent>;

interface SafeAreaContentProps extends Omit<IonContentProps, "children"> {
  children: ReactNode;
}

/**
 * Combined IonContent and SafeAreaInjector component.
 * Wraps IonContent with SafeAreaInjector to automatically inject
 * safe area CSS variables from root into the content area.
 */
export const SafeAreaContent = ({ children, className, style, ...rest }: SafeAreaContentProps) => {
  const safeAreaStyles = useSafeAreaStyles();
  return (
    <IonContent
      fullscreen
      className={className}
      style={{
        ...safeAreaStyles,
        ...style,
      }}
      {...rest}
    >
      {children}
    </IonContent>
  );
};
